module.exports = __webpack_public_path__ + "img/read-more-icon.ad5f4fed.svg";